import { Pagination } from '@cinch-nx/shared-ui'
import { useRouter } from 'next/router'

interface ReviewPaginationHubProps {
  currentPage: number
  total: number
  resultsPerPage?: number
  isISR?: boolean
}

export const ReviewHubPagination: React.FC<ReviewPaginationHubProps> = ({
  currentPage,
  resultsPerPage = 10,
  total,
  isISR = false,
}) => {
  const { isFallback, query, asPath } = useRouter()
  const dict: Record<string, string> = {}

  if (isISR) {
    /*
     ** Please note this is very hacky and should be refactored
     ** In this case 'make' is actually the first part of the path immendiately after '/reviews/'
     ** And 'model' is actually the second part of the path immendiately after '/make/'
     ** The values of make could be actual car makes or 'page'
     ** likewise the values of model could be actual car models or 'page'
     */
    const [make, model] = asPath.split('/').slice(2)

    if (make && make !== 'page') {
      dict.make = make
    }

    if (model) {
      dict.model = model
    }
  } else {
    if (typeof query.make === 'string') {
      dict.make = query.make

      if (typeof query.model === 'string') {
        dict.model = query.model
      }
    }
  }

  const queryString = new URLSearchParams(dict).toString()

  if (isFallback) {
    return null
  }

  const sourcePage = isISR && dict.make ? `reviews/${dict.make}` : 'reviews'

  return (
    <Pagination
      totalItemsCount={total}
      activePage={currentPage}
      itemsCountPerPage={resultsPerPage}
      sourcePage={sourcePage}
      enabledLinks={true}
      includedQueryParams={
        queryString.length > 0 && isISR === false
          ? `?${queryString.toString()}`
          : ''
      }
    />
  )
}
